import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            浏览<strong>精彩内容</strong>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">选择你喜欢的分类，发现更多精彩影视</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 text-center leading-relaxed">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}